import React from 'react';
import ReactDataSheet from 'react-datasheet';

export function Sheet({
  rows = [],
  onChange,
  value,
  filter = () => true,
  className = '',
  t,
}) {
  return (
    <ReactDataSheet
      className={`${className} accounting`}
      data={[
        [
          {
            readOnly: true,
            value: t('resources.accounting-plans.fields.acc-name'),
            className: 'header',
          },
          {
            readOnly: true,
            value: t('resources.accounting-plans.fields.acc-number'),
            className: 'header',
          },
        ],
        ...rows.filter(filter).map((row) => [
          { readOnly: true, id: row.name, value: row.name, col: 'name' },
          {
            id: row.name,
            value: row.id || row.defaultId,
            col: 'id',
            className: `${!row.id ? 'empty' : ''} ${
              (!row.id && row.defaultId) || row.usesDefault ? 'default' : ''
            }`,
            index: row.index,
          },
        ]),
      ]}
      valueRenderer={(cell) => cell.value}
      onCellsChanged={(changes) => {
        const newRows = rows;
        changes.forEach((change) => {
          newRows[change.cell.index][change.cell.col] = change.value;
          newRows[change.cell.index].usesDefault = false;
        });
        const updatedPlan = newRows.reduce(
          (prev, current) => ({ ...prev, [current.name]: current }),
          value || {},
        );
        return onChange(updatedPlan);
      }}
    />
  );
}
